(() => {
  const body = document.body;
  const live = body.dataset.commerce === 'true' && body.dataset.launchApproved === 'true';
  const preview = body.dataset.preview === 'true';
  const root = body.dataset.root || '/';
  const themeId = body.dataset.themeId;
  const localized = path => `${root.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  if (preview) {
    const visitorStoreId = location.hostname.match(/-([0-9]+)\.shopifypreview\.com$/i)?.[1];
    for (const link of document.querySelectorAll('a[href]')) {
      const raw = link.getAttribute('href');
      if (!raw || raw.startsWith('#') || /^(mailto:|tel:)/i.test(raw)) continue;
      if (link.closest('[data-native-filter-form],.gym-pagination,.gym-empty')) continue;
      const url = new URL(raw, document.baseURI);
      const linkedStoreId = url.hostname.match(/-([0-9]+)\.shopifypreview\.com$/i)?.[1];
      if (visitorStoreId && linkedStoreId === visitorStoreId && url.protocol === 'https:' && url.pathname === '/products_preview' && url.searchParams.has('preview_key')) {
        link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
        continue;
      }
      if (url.origin !== location.origin || /\/account|\/policies\//.test(url.pathname)) continue;
      url.searchParams.set('preview_theme_id', themeId);
      if (raw.includes(',')) url.search = url.search.replace(/%2C/gi, ',');
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    }
  }
  if (preview && themeId) {
    for (const form of document.querySelectorAll('form[method="get" i]')) {
      if (form.matches('[data-native-filter-form]')) continue;
      let input = form.querySelector('input[name="preview_theme_id"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; form.appendChild(input); }
      input.value = themeId;
    }
  }
  const lightbox = document.querySelector('.mxg-lightbox');
  let lightboxItems = [];
  let lightboxIndex = 0;
  let returnFocus;
  const showPhoto = index => {
    if (!lightboxItems.length) return;
    lightboxIndex = (index + lightboxItems.length) % lightboxItems.length;
    const item = lightboxItems[lightboxIndex];
    const image = lightbox.querySelector('figure img');
    image.src = item.src;
    image.alt = item.alt;
    lightbox.querySelector('figcaption').textContent = `${item.alt} (${lightboxIndex + 1}/${lightboxItems.length})`;
    lightbox.querySelector('[data-lightbox-prev]').hidden = lightboxItems.length < 2;
    lightbox.querySelector('[data-lightbox-next]').hidden = lightboxItems.length < 2;
  };
  const openPhoto = (items, index, trigger) => {
    lightboxItems = items;
    returnFocus = trigger;
    showPhoto(index);
    if (!lightbox.open) lightbox.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  lightbox?.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
  lightbox?.querySelector('[data-lightbox-prev]').addEventListener('click', () => showPhoto(lightboxIndex - 1));
  lightbox?.querySelector('[data-lightbox-next]').addEventListener('click', () => showPhoto(lightboxIndex + 1));
  lightbox?.addEventListener('close', () => {
    document.documentElement.style.overflow = '';
    returnFocus?.focus();
  });
  lightbox?.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
  lightbox?.addEventListener('keydown', event => {
    if (event.key === 'Tab') {
      const controls = [...lightbox.querySelectorAll('button:not([disabled])')]
        .filter(button => !button.hidden && button.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      const active = document.activeElement;
      if (event.shiftKey && (active === first || !controls.includes(active))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (active === last || !controls.includes(active))) {
        event.preventDefault(); first.focus();
      }
    }
    if (event.key === 'ArrowLeft') { event.preventDefault(); showPhoto(lightboxIndex - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); showPhoto(lightboxIndex + 1); }
  });
  for (const gallery of document.querySelectorAll('[data-gallery]')) {
    const thumbs = [...gallery.querySelectorAll('[data-gallery-src]')];
    let active = 0;
    const image = gallery.querySelector('.mxg-main-image');
    const items = thumbs.map(button => ({src: button.dataset.gallerySrc, alt: button.dataset.galleryAlt}));
    for (const [index, button] of thumbs.entries()) {
      button.addEventListener('click', () => {
        active = index;
        if (image) {
          image.src = button.dataset.gallerySrc;
          image.removeAttribute('srcset');
          image.alt = button.dataset.galleryAlt;
        }
        for (const thumb of thumbs) {
          thumb.classList.toggle('is-selected', thumb === button);
          thumb.setAttribute('aria-pressed', String(thumb === button));
        }
      });
    }
    const viewButtons = [...(gallery.closest('.mxg-gallery-column')?.querySelectorAll('[data-gallery-view]') || [])];
    const syncPhotoMode = () => {
      if (!thumbs.length) {
        for (const button of viewButtons) {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        }
        return;
      }
      const mode = thumbs[active]?.dataset.galleryKind === 'professional' ? 'professional' : 'actual';
      for (const button of viewButtons) {
        const selected = button.dataset.galleryView === mode;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      }
      const caption = gallery.querySelector('[data-photo-caption]');
      if (caption) caption.textContent = mode === 'professional'
        ? gallery.dataset.professionalCaption
        : gallery.dataset.actualCaption;
    };
    for (const button of thumbs) button.addEventListener('click', syncPhotoMode);
    for (const button of viewButtons) button.addEventListener('click', () => {
      const target = thumbs.find(thumb => thumb.dataset.galleryKind === button.dataset.galleryView);
      if (target) target.click();
    });
    syncPhotoMode();
    for (const button of gallery.querySelectorAll('[data-zoom-current]')) button.addEventListener('click', () => openPhoto(items, active, button));
  }
  const actual = [...document.querySelectorAll('[data-lightbox-src]')];
  for (const [index, button] of actual.entries()) button.addEventListener('click', () => openPhoto(actual.map(x => ({src:x.dataset.lightboxSrc, alt:x.dataset.lightboxAlt || ''})), index, button));
  for (const tabset of document.querySelectorAll('[data-tabs]')) {
    const tabs = [...tabset.querySelectorAll('[role=tab]')];
    const select = selected => {
      for (const tab of tabs) {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      }
    };
    for (const [index, tab] of tabs.entries()) {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index + tabs.length - 1) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) { event.preventDefault(); select(next); next.focus(); }
      });
    }
    tabset.classList.add('is-enhanced');
    if (tabs[0]) select(tabs[0]);
  }
  const quantitySync = wrapper => {
    const input = wrapper.querySelector('input');
    const minimum = Math.max(0, Number(input.min) || 0);
    const step = Math.max(1, Number(input.step) || 1);
    const maximum = input.max === '' ? 0 : Math.max(0, Math.floor(Number(input.max) || 0));
    const min = maximum < minimum ? 0 : minimum;
    const max = maximum < minimum ? 0 : maximum;
    let current = Number(input.value);
    if (!Number.isFinite(current)) current = min;
    current = Math.min(max, Math.max(min, current));
    current = min + Math.floor((current - min) / step) * step;
    input.value = String(current);
    input.disabled = max === 0;
    wrapper.querySelector('[data-quantity-step="-1"]').disabled = max === 0 || current <= min;
    wrapper.querySelector('[data-quantity-step="1"]').disabled = max === 0 || current + step > max;
    const product = wrapper.closest('[data-product-root]');
    const button = product?.querySelector('.mxg-add-to-cart');
    const released = product?.dataset.releaseApproved === 'true';
    const priced = Number(product?.dataset.priceAmount) > 0;
    if (button) button.disabled = !live || !released || !priced || max === 0 || current < minimum;
    return max > 0 && current >= minimum;
  };
  for (const wrapper of document.querySelectorAll('.mxg-quantity')) {
    const input = wrapper.querySelector('input');
    for (const button of wrapper.querySelectorAll('[data-quantity-step]')) button.addEventListener('click', () => {
      const step = Number(input.step) || 1;
      input.value = String((Number(input.value) || Number(input.min) || 1) + Number(button.dataset.quantityStep) * step);
      quantitySync(wrapper);
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
    input.addEventListener('input', () => quantitySync(wrapper));
    input.addEventListener('change', () => quantitySync(wrapper));
    quantitySync(wrapper);
  }
  for (const select of document.querySelectorAll('[data-variant-select]')) select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    const product = select.closest('[data-product-root]');
    const button = product?.querySelector('.mxg-add-to-cart');
    const wrapper = product?.querySelector('.mxg-quantity');
    const input = wrapper?.querySelector('input');
    if (product) product.dataset.priceAmount = option.dataset.priceAmount || '0';
    if (input) {
      input.min = option.dataset.quantityMin || '1';
      input.step = option.dataset.quantityStep || '1';
      input.max = option.dataset.available === 'true' ? option.dataset.quantityMax || '0' : '0';
      input.value = input.min;
      quantitySync(wrapper);
    }
    if (button && option.dataset.available !== 'true') button.disabled = true;
    if (live && product && product.dataset.priceApproved === 'true') product.querySelector('[data-price]').textContent = option.dataset.price;
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState(null, '', url);
  });
  for (const form of document.querySelectorAll('[data-product-form]')) form.addEventListener('submit', async event => {
    event.preventDefault();
    const product = form.closest('[data-product-root]');
    if (!live || product?.dataset.releaseApproved !== 'true' || !(Number(product?.dataset.priceAmount) > 0)) return;
    const wrapper = form.querySelector('.mxg-quantity');
    if (!wrapper || !quantitySync(wrapper)) return;
    const quantityInput = wrapper.querySelector('input');
    const submittedQuantity = Number(quantityInput.value);
    const button = form.querySelector('[type=submit]');
    if (button?.disabled) return;
    const status = form.querySelector('[data-product-status]');
    if (button) button.disabled = true;
    try {
      const response = await fetch(localized('cart/add.js'), {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || body.dataset.cartError);
      quantityInput.max = String(Math.max(0, Number(quantityInput.max) - submittedQuantity));
      const selectedOption = form.querySelector('[data-variant-select]')?.selectedOptions[0];
      if (selectedOption) selectedOption.dataset.quantityMax = quantityInput.max;
      quantitySync(wrapper);
      const cartResponse = await fetch(localized('cart.js'), {headers:{Accept:'application/json'}});
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        for (const count of document.querySelectorAll('[data-cart-count]')) count.textContent = String(cart.item_count);
      }
      if (status) status.textContent = body.dataset.cartAdded;
      const toast = document.querySelector('.mxg-toast');
      if (toast) { toast.textContent = body.dataset.cartAdded; toast.hidden = false; setTimeout(() => toast.hidden = true, 4500); }
    } catch (error) {
      if (status) status.textContent = error.message;
    } finally {
      quantitySync(wrapper);
    }
  });
  for (const input of document.querySelectorAll('[data-cart-stock-cap]')) {
    const clampCartQuantity = () => {
      const max = Math.max(0, Math.floor(Number(input.max) || 0));
      const value = Math.floor(Number(input.value) || 0);
      input.value = String(Math.min(max, Math.max(0, value)));
    };
    input.addEventListener('input', clampCartQuantity);
    input.addEventListener('change', clampCartQuantity);
    input.form?.addEventListener('submit', clampCartQuantity);
    clampCartQuantity();
  }
  for (const catalog of document.querySelectorAll('[data-catalog]')) {
    const grid = catalog.querySelector('[data-catalog-grid]');
    const cards = [...grid.querySelectorAll('[data-product-card]')];
    const filters = [...catalog.querySelectorAll('[data-filter]')];
    const sort = catalog.querySelector('[data-catalog-sort]');
    const search = catalog.querySelector('[data-search-input]');
    const count = catalog.querySelector('[data-result-count]');
    const empty = catalog.querySelector('[data-empty-results]');
    const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const refresh = () => {
      const terms = normalize(search?.value).trim().split(/\s+/).filter(Boolean);
      let visible = 0;
      const order = [...cards];
      if (sort?.value === 'az') order.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
      if (sort?.value === 'za') order.sort((a,b) => b.dataset.title.localeCompare(a.dataset.title));
      if (sort?.value === 'low') order.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
      if (sort?.value === 'high') order.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
      for (const card of order) {
        const matches = filters.every(filter => !filter.value || card.dataset[filter.dataset.filter] === filter.value) && terms.every(term => normalize(card.dataset.title + ' ' + card.dataset.audience).includes(term));
        card.hidden = !matches;
        if (matches) visible++;
        grid.appendChild(card);
      }
      if (count) count.textContent = `${visible} ${visible === 1 ? body.dataset.resultOne : body.dataset.resultMany}`;
      if (empty) empty.hidden = visible > 0;
    };
    for (const filter of filters) filter.addEventListener('change', refresh);
    sort?.addEventListener('change', refresh);
    search?.addEventListener('input', refresh);
    catalog.querySelector('[data-clear-filters]')?.addEventListener('click', () => {for (const filter of filters) filter.value = '';refresh();});
    if (preview && search && !catalog.hasAttribute('data-search-native')) catalog.querySelector('form[role=search]')?.addEventListener('submit', event => {
      event.preventDefault();refresh();const url = new URL(location.href);url.searchParams.set('q', search.value);history.replaceState(null,'',url);
    });
    if (cards.length) refresh();
  }
  document.addEventListener('keydown', event => { if (event.key === 'Escape') for (const menu of document.querySelectorAll('.mxg-mobile-menu[open]')) menu.removeAttribute('open'); });
})();


